module.exports = __webpack_public_path__ + "static/media/icon_circle_white.9992ec1f.svg";